import { Popover } from "@headlessui/react";
import { CheckCircleIcon, ClipboardDocumentListIcon } from "@heroicons/react/24/outline";
import { useJobCardEligibilityAPI } from "@/app/hooks/api_hooks/Cart/useJobCardEligibilityAPI";

type JobCardEligibilityData = ReturnType<typeof useJobCardEligibilityAPI>["data"];

interface CartJobCardEligibilityCardProps {
  jobCardEligibility: JobCardEligibilityData;
  onUploadJobCard: (pet: { id: string; name: string }) => void;
  buttonClassName: string;
}

const CartJobCardEligibilityCard = ({
  jobCardEligibility,
  onUploadJobCard,
  buttonClassName,
}: CartJobCardEligibilityCardProps) => {
  const pendingCount = jobCardEligibility?.pets?.filter((pet) => !pet.job_card_present).length ?? 0;

  return (
    <Popover className="relative">
      <Popover.Button
        className={`${buttonClassName} ${
          pendingCount > 0
            ? "border-red-200 bg-red-50 text-red-600 hover:bg-red-100"
            : "border-blue-200 bg-white text-[#0068FF] hover:border-blue-300 hover:bg-blue-50"
        }`}
      >
        {pendingCount > 0 ? <ClipboardDocumentListIcon className="h-4 w-4" /> : <CheckCircleIcon className="h-4 w-4" />}
        Job Card
        {pendingCount > 0 && (
          <span className="rounded-full bg-red-600 px-1.5 text-[10px] leading-4 text-white">{pendingCount}</span>
        )}
      </Popover.Button>
      <Popover.Panel className="absolute right-0 z-40 mt-2 w-[280px] rounded-xl border border-gray-100 bg-white p-4 shadow-lg">
        <h1 className="text-black text-sm font-medium">Job Card Eligibility</h1>
        {jobCardEligibility?.pets?.length ? (
          <div className="mt-2 space-y-2">
            {jobCardEligibility.pets.map((pet) => (
              <div key={pet.id} className="border-[#ececec] p-3 border rounded-xl">
                <div className="flex items-center justify-between">
                  <p className="font-medium text-xs">{pet.name}</p>
                  {pet.job_card_present ? (
                    <span className="text-xs font-medium text-[#07863d]">Uploaded</span>
                  ) : (
                    <button
                      type="button"
                      className="rounded-md px-2 py-1 text-xs font-medium text-red-500 hover:bg-[#f9fafb]"
                      title="Upload job card"
                      onClick={() => onUploadJobCard(pet)}
                    >
                      Upload Job Card
                    </button>
                  )}
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-black text-xs pt-2">No Job Card Required</div>
        )}
      </Popover.Panel>
    </Popover>
  );
};

export default CartJobCardEligibilityCard;
